module.exports = __webpack_public_path__ + "img/classics33.11bb083.jpg";